module.exports = __webpack_public_path__ + "static/img/132.00bb92eb.png";